export default [
  {
    path: '/program/programCompany',
    component: resolve => require(['@/pages/program/programCompany.vue'], resolve),
    name: 'programCompany',
    meta: {
      title: '勤工助学-单位管理'
    }
  },
  // 用工单位详情
  {
    path: '/program/programCompanyDetail',
    component: resolve => require(['@/pages/program/programCompanyDetail.vue'], resolve),
    name: 'programCompanyDetail',
    meta: {
      title: '单位管理详情'
    }
  },
  // 学工详情
  {
    path: '/program/programStudentWork',
    component: resolve => require(['@/pages/program/programStudentWork.vue'], resolve),
    name: 'programStudentWork',
    meta: {
      title: '单位管理详情'
    }
  },
  {
    path: '/program/programStudentWorkDetail',
    component: resolve => require(['@/pages/program/programStudentWorkDetail.vue'], resolve),
    name: 'programStudentWorkDetail',
    meta: {
      title: '用工单位详情'
    }
  },
  {
    path: '/program/programPost',
    component: resolve => require(['@/pages/program/programPost.vue'], resolve),
    name: 'programPost',
    meta: {
      title: '勤工助学-岗位管理'
    }
  },
  {
    path: '/program/jobApplySeting',
    component: resolve => require(['@/pages/program/programJobApplySeting.vue'], resolve),
    name: 'programJobApplySeting',
    meta: {
      title: '岗位申请设置'
    }
  },
  {
    path: '/program/addStudentList',
    component: resolve => require(['@/pages/program/addStudentList.vue'], resolve),
    name: 'programAddStudentList',
    meta: {
      title: '用工岗位选人'
    }
  },
]


// WEBPACK FOOTER //
// ./src/router/modules/program.js